import CommonLogin from '../../../common/pages/public/Login'

class Login extends CommonLogin {
  constructor (props) {
    super(props)
    this.loginFormTitle = '日本型枠工事業協会'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/company_user/pages/public/Login.js